angular.module('tgaAdmin')
  .controller('HubListController', [
    '$scope', '$state', 'hubService', 'modalService', '$timeout', 'userService', 'divisionService', '$uibModal', 'domainService',
    function (
      $scope, $state, hubService, modalService, $timeout, userService, divisionService, $uibModal, domainService,
    ) {
      $scope.data = {
        alerts: [],
        isAdmin: userService.checkUserType(['admin', 'sales_admin', 'support_admin', 'super_admin']),
        isCreator: userService.checkUserType(['editor', 'creator_admin']),
        isViewerAdmin: userService.checkUserType(['viewer_admin']),
        arcadesEnabled: true,
        subscription_expired: false,
      };

      $scope.viewmodel = {
        range: 'Last 30 Days',
        oldRange: {
          startDate: moment().subtract(29, 'days').startOf('day'),
          endDate: moment().endOf('day'),
        },
        dateRange: {
          startDate: moment().subtract(29, 'days').startOf('day'),
          endDate: moment().endOf('day'),
        },
        hubs: [],
      };

      $scope.initialize = function () {
        domainService.getSubscription().then((subscription) => {
          $scope.data.arcadesEnabled = subscription.items.some((item) => {
            return item.permission === 'addon.arcades';
          });
        });

        divisionService.getDivisions().then((divisions) => {
          $scope.data.divisions = divisions;
        });
      };

      $scope.actions = {
        copyHub(hub) {
          modalService.showModal({
            title: 'Copy Arcade',
            message: 'Would you like to create a copy of this arcade?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            hub.processing = true;

            hubService.copyHub(hub.hub_id).then(() => {
              $scope.actions.loadHubs();
              hub.processing = false;
              $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade copied.', 'success');
            });
          }).catch(angular.noop);
        },
        archiveHub(hub) {
          modalService.showModal({
            title: 'Archive Arcade?',
            message: 'Are you sure you want to archive this arcade?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            hub.processing = true;

            hubService.archiveHub({
              hub_id: hub.hub_id,
              is_archived: 1,
            }).then(
              () => {
                $scope.actions.loadHubs();
                hub.processing = false;
                $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade archived.', 'success');
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                hub.processing = false;
              },
            );
          }, () => { });
        },
        deleteHub(hub) {
          modalService.showModal({
            title: 'Delete Arcade?',
            message: 'Are you sure you want to delete this arcade?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            hub.processing = true;

            hubService.deleteHub({
              hub_id: hub.hub_id,
              is_deleted: 1,
            }).then(
              () => {
                $scope.actions.loadHubs();
                hub.processing = false;
                $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade deleted.', 'success');
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                hub.processing = false;
              },
            );
          }, () => { });
        },
        // eslint-disable-next-line consistent-return
        exportReport() {
          if (!$scope.viewmodel.hubs.length) {
            return false;
          }

          $uibModal.open({
            animation: true,
            templateUrl: 'templates/partials/modal-report.html',
            controller: 'ReportModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  report: {
                    report_type: 'arcades_report',
                  },
                };
              },
            },
          }).result.catch(angular.noop);
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        loadHubs(tableState) {
          $scope.loading = true;
          const params = tableState ? {
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            order: tableState.sort.reverse ? 'desc' : 'asc',
            start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
            end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
            stats: true,
          } : {};

          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              // Check for divisions first and set values to a divisions array
              if (key === 'divisions') {
                params['divisions[]'] = Object
                  .keys(tableState.search.predicateObject.divisions)
                  .map((divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value);
              } else {
                params[key] = tableState.search.predicateObject[key];
              }
            });
          }
          hubService.getHubs(params).then((response) => {
            $scope.loading = false;
            $scope.viewmodel.hubs = response.items || response;
            $scope.data.subscription_expired = $scope.viewmodel.hubs.some(item => {
              return item.past_exp === true;
            });
            $scope.loading = false;
            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }
          });
        },
      };

      $scope.initialize();
    },
  ]);
